import type { Messages } from "@lingui/core";

// Preserve upstream message IDs and translations while branding displayed text.
// Compiled ICU arrays contain text and operands; only string leaves change.
export function brandMessages(
  messages: Messages,
  upstreamIds = new Set<string>(),
): Messages {
  function replace<T>(value: T): T {
    if (typeof value === "string")
      return value.replace(/\bStoat\b/g, "Lilith-work") as T;
    if (Array.isArray(value)) return value.map(replace) as T;
    if (value && typeof value === "object")
      return Object.fromEntries(
        Object.entries(value).map(([key, item]) => [key, replace(item)]),
      ) as T;
    return value;
  }
  return Object.fromEntries(
    Object.entries(messages).map(([id, value]) => [
      id,
      upstreamIds.has(id) ? value : replace(value),
    ]),
  );
}
